var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRigthBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 21.452C1.01272 16.0192 3.18149 10.8136 7.02979 6.97884C10.8781 3.14403 16.0911 0.993654 21.5239 1.00001C26.9567 1.00637 32.1648 3.16897 36.0042 7.01277C39.8435 10.8566 42 16.0672 42 21.5C42 26.9327 39.8435 32.1435 36.0042 35.9873C32.1648 39.8311 26.9567 41.9936 21.5239 42C16.0911 42.0063 10.8781 39.8559 7.02979 36.0211C3.18149 32.1863 1.01272 26.9808 1 21.548V21.452Z",
    stroke: "#DEDFE3",
    strokeWidth: 1.90698,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5421 22.0518L19.7902 27.8038C19.657 27.937 19.4764 28.0117 19.2881 28.0117C19.0998 28.0117 18.9193 27.937 18.7861 27.8038L18.1151 27.1338C17.9819 27.0008 17.9069 26.8202 17.9067 26.632C17.9066 26.4437 17.9811 26.263 18.1141 26.1298L22.6721 21.5498L18.1141 16.9698C17.9813 16.8367 17.9067 16.6563 17.9067 16.4683C17.9067 16.2802 17.9813 16.0999 18.1141 15.9668L18.7861 15.2968C18.9193 15.1636 19.0998 15.0889 19.2881 15.0889C19.4764 15.0889 19.657 15.1636 19.7902 15.2968L25.5421 21.0468C25.6082 21.1127 25.6607 21.1911 25.6964 21.2773C25.7322 21.3636 25.7505 21.456 25.7505 21.5493C25.7505 21.6427 25.7322 21.7351 25.6964 21.8213C25.6607 21.9075 25.6082 21.9858 25.5421 22.0518Z",
    fill: "#DEDFE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRigthBtn);
export default __webpack_public_path__ + "static/media/RigthBtn.c0ae394748eebe439c82138aadfda2e0.svg";
export { ForwardRef as ReactComponent };